import React, { useEffect, useState } from 'react';
import { Button, Grid, useMediaQuery, useTheme } from '@material-ui/core';
import { useStyles } from './FabricaInsumosAppbarStyles';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';



export const FabricaInsumosAppbar = props => {
  const {
    fabricar,
    cancelar
  } = props;
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });

  return (
    <Grid
      container
    >
      <Grid
        item
        md={12}
        xs={12}
        className={classes.gridBotoes}
      >
        <Grid
          container
          spacing={1}
        >
          <Grid
            item
            md={6}
            xs={12}
            className={classes.gridBotaoCancelar}
          >
            <Button
              color={'primary'}
              variant={'contained'}
              startIcon={<CancelIcon/>}
              className={classes.botaoCancelar}
              onClick={cancelar}
              fullWidth={!isDesktop}
            >
              CANCELAR
            </Button>
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
            className={classes.gridBotaoFinalizar}
          >
            <Button
              color={'primary'}
              variant={'outlined'}
              startIcon={<CheckCircleOutlineIcon/>}
              fullWidth={!isDesktop}
              onClick={fabricar}

            >
              FINALIZAR
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
};
